import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withState } from 'recompose';
import classnames from 'classnames';
import Slider, { createSliderWithTooltip } from 'rc-slider';

import { Label } from 'components/core/Label';
import { Paragraph } from 'components/core/Typography';

import './SliderInput.scss';

let sliderInputId = 0;

function getHelpText(helpTexts, value) {
	const index = parseInt(value) - 1;
	return helpTexts && index < helpTexts.length ? helpTexts[index] : null;
}

export const enhance = compose(
	withState('helpText', 'setHelpText', ({ helpTexts, defaultValue }) =>
		getHelpText(helpTexts, defaultValue),
	),
	withHandlers(({ onChange, helpTexts, setHelpText }) => ({
		onChange: () => (value) => {
			setHelpText(getHelpText(helpTexts, value));
			onChange(value);
		},
	})),
);

export const SliderInput = ({
	tooltip,
	id,
	label,
	helpText,
	error,
	onChange,
	defaultValue,
	min,
	max,
	step,
}) => {
	const SInput = tooltip ? createSliderWithTooltip(Slider) : Slider;
	return (
		<Label
			htmlFor={id}
			text={label}
			className={classnames('ss-slider-input-label', { error })}
			render={(renderProps) => (
				<Fragment>
					<div className="slider-input">
						<SInput
							id={renderProps.id}
							min={min}
							max={max}
							step={step}
							defaultValue={defaultValue}
							onChange={onChange}
						/>
						{!!helpText && (
							<div className="help-text">{helpText}</div>
						)}
					</div>
					{error && (
						<Paragraph className="error-message">{error}</Paragraph>
					)}
				</Fragment>
			)}
		/>
	);
};

SliderInput.propTypes = {
	tooltip: PropTypes.bool,
	id: PropTypes.string,
	label: PropTypes.string,
	helpText: PropTypes.string,
	error: PropTypes.string,
	onChange: PropTypes.func,
	defaultValue: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
};

SliderInput.defaultProps = {
	id: `ss-slider-input-${(sliderInputId += 1)}`,
};

export default enhance(SliderInput);
